import "./Footer.css"

const Footer = () => {
    return <footer className="footer" style={{backgroundImage: "url(/img/footer.png)"}}>
        <div className="redes">
            <a href="https://www.linkedin.com/in/vaninadenegri/" target="_blank">
                <img src="/img/linkedin.png" alt="LinkedIn"/>
            </a>
            <a href="https://github.com/VannDennOk" target="_blank">
                <img src="/img/github.png" alt="GitHub"/>
            </a>
        </div>
        <img src="/img/Logo.png" alt="org"/>
        <strong>Desarrollado por Vanina Denegri para el Programa ONE de Alura Latam + Oracle</strong>
</footer>
}

export default Footer